export const overlayVariants = {
    hidden: {
        opacity: 0,
    },
    shown: {
        opacity: 0.7,
    },
};

export const modalVariants = {
    hidden: {
        opacity: 0,
    },
    shown: {
        opacity: 1,
    },
};
